export const FETCHING_APP_NOTIFICATIONS = "FETCHING.APP_NOTIFICATIONS";
export const FETCHED_APP_NOTIFICATIONS = "FETCHED.APP_NOTIFICATIONS";
export const ERROR_FETCHING_APP_NOTIFICATIONS = "ERROR.FETCHING.APP_NOTIFICATIONS";

export const DELETING_APP_NOTIFICATION = "DELETING.APP_NOTIFICATION";
export const DELETED_APP_NOTIFICATION = "DELETED.APP_NOTIFICATION";
export const ERROR_DELETING_APP_NOTIFICATION = "ERROR.DELETING.APP_NOTIFICATION";
